import Url from "../lib/url.js";
import TokenStorage from "./token-storage.js";
import Application from "./application.js";
import Semaphore from "../lib/semaphore.js";

export default {
    data() {
        return {
            logined: false,
            currentUser: null,
            userSemaphore: null
        }
    },
    async created() {
        this.userSemaphore = new Semaphore();
        
        if (Application.mock.login) {
            this.currentUser = {
                id: 1,
                username: "mock"
            };
            this.logined = true;
            return;
        }
        let logined = await this.$remotes.server.auth.isLogin();
        if (logined) {
            let user = await this.$remotes.server.auth.mineInfo();
            user.avatar = Application.server + "/mine/getAvatar?token=" + user.avatar;
            this.currentUser = user;
        }
        this.logined = logined;
        
        this.userSemaphore.release();
    },
    methods: {
        login() {
            let nowUrl = Url.encode(window.location.href);
            window.location.href = "login.html?redirect-url=" + nowUrl;
        },
        logout() {
            TokenStorage.clear();
            this.logined = false;
            this.currentUser = null;
        },
        hasPermission(permission) {
            if (typeof permission == "object") {
                permission = permission.meta;
            }
            return this.logined && this.currentUser.permissions.indexOf(permission) >= 0;
        }
    }
};